import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PracticesListPageRoutingModule } from './practices-list-routing.module';

import { PracticesListPage } from './practices-list.page';
import { HeaderModule } from 'src/app/_component/header/header.module';
import { InfoPageModule } from '../info/info.module';
import { ItemCommunityModule } from '../community/item-community/item-community.module';
import { SearchBarModule } from '../_component/search-bar/search-bar.module';
import { TranslateModule } from '@ngx-translate/core';
import { NoResultModule } from '../_component/no-result/no-result.module';
import { SharedDirectivesModule } from 'src/app/_directives/shared-directives.module';
import { LoadingStiModule } from 'src/app/_component/loading-sti/loading-sti.module';
import { CommentModule } from '../_component/comment/comment.module';
import { BreadcrumbComponentModule } from '../_component/breadcrumb/breadcrumb.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PracticesListPageRoutingModule,
    HeaderModule,
    InfoPageModule,
    ItemCommunityModule,
    SearchBarModule,
    TranslateModule,
    NoResultModule,
    SharedDirectivesModule,
    LoadingStiModule,
    CommentModule,
    BreadcrumbComponentModule,
  ],
  declarations: [
    PracticesListPage
  ],
  providers: []
})
export class PracticesListPageModule {}
